import { useQuery } from "@/compat/reactQuery";
import queryKeys from "../../constants/queryKeys";
import knowledgeBankService from "../../services/knowledgeBankService";

const useKnowledgeBankEvent = (id) =>
    useQuery(
        [queryKeys.knowledgeBankArticle, id],
        () => knowledgeBankService.getEvent(id),
        {
            staleTime: Infinity
        }
    )

export default useKnowledgeBankEvent;
